"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _Highcharts = _interopRequireDefault(require("./Highcharts.config"));
var _theme = require("../utils/theme");
var _excluded = ["theme", "children", "opts"];
var Chart = function Chart(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    children = _ref.children,
    _ref$opts = _ref.opts,
    opts = _ref$opts === void 0 ? {} : _ref$opts,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_highchartsReactOfficial["default"], (0, _extends2["default"])({
    highcharts: _Highcharts["default"],
    options: opts,
    allowChartUpdate: true,
    containerProps: {
      className: 'chartContainer'
    }
  }, props)));
};
var _default = exports["default"] = Chart;